export default __webpack_public_path__ + "static/media/Gap Attack.4ca3304e.png";